export enum RouteIds {
  buildYourCourse = 'build-your-course',
  yourInformation = 'your-information',
  confirmation = 'confirmation',
}
